import {React , useState} from 'react'
import './UploadModal.css'
import Modal from './UploadForm'
import {CloudUploadOutlined} from '@ant-design/icons'


const UploadModal = () => {
  const [open, setOpen] = useState(false);
 
return (
  <div className="container">
   <button id="upload-btn" onClick={() => setOpen(true)}> <CloudUploadOutlined /> UPLOAD</button>

   <Modal open={open} onClose={() => setOpen(false)}>
         
        </Modal>

    </div>
)
    
}


export {UploadModal }